import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-entrance-exit-entry-dialog',
  templateUrl: './manual-entrance-exit-entry-dialog.component.html',
  styleUrls: ['./manual-entrance-exit-entry-dialog.component.css'],
  standalone: false,
})
export class ManualEntranceExitEntryDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly reflectDataLink: string = AppConst.ROUTING_LINK_MANUAL_REFLECT_DATA;

  currentLang: string = 'ja';


  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
